import { ConfigProvider, Switch } from "antd";
import { memo } from "react";

interface ValidationSwitchProps {
  switchStore: boolean;
  setSwitchStore: (value: boolean) => void;
}

export const ValidationSwitch = memo(
  ({ switchStore, setSwitchStore }: ValidationSwitchProps) => {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#030521",
          },
        }}
      >
        <Switch
          checkedChildren={
            <p style={{ paddingTop: "2px", fontWeight: "bold" }}>
              CORRECTO ✅
            </p>
          }
          unCheckedChildren={
            <p
              style={{
                color: "red",
                paddingTop: "2px",
                fontWeight: "bold",
              }}
            >
              ERROR 🆘
            </p>
          }
          value={switchStore}
          onChange={setSwitchStore}
        />
      </ConfigProvider>
    );
  },
  // Comparación personalizada para evitar re-renders innecesarios
  (prevProps, nextProps) => {
    return prevProps.switchStore === nextProps.switchStore;
  }
);

ValidationSwitch.displayName = "ValidationSwitch";